// NOTE: This file was taken from web-app. It runs in 'dev' and 'staging' and allows us to manually set
// features on for testing. If the feature is not found in localStorage, the existing behavior of isFeatureEnabled
// is called. We will replace this file with the appropriate util package in web-utils once it is added in
// the future.
import { Client } from '@optimizely/optimizely-sdk'
import QueryString from 'query-string'

const OPTIMIZELY_OVERRIDE = 'optimizely_feature_override:'

export const initializeOptimizelyOverride = (optimizely: Client) => {
  const queryParams = `${window.location.search}`

  if (queryParams.includes('feature_overrides')) {
    const queryString = QueryString.parse(queryParams)

    if (typeof queryString.feature_overrides === 'string') {
      const features = queryString.feature_overrides
        .split(',')
        .map((featureToggle: string) => featureToggle.split('.'))

      features.forEach((feature: string[]) => setFeatureOverride(feature))
    }
  }
  shimOptimizelyClient(optimizely)
}

export const setFeatureOverride = (feature: string[]) => {
  localStorage.setItem(`${OPTIMIZELY_OVERRIDE}${feature[0]}`, feature[1])
}

export const removeFeatureOverride = (feature: string) => {
  localStorage.removeItem(`${OPTIMIZELY_OVERRIDE}${feature}`)
}

export const shimOptimizelyClient = (optimizely: Client) => {
  const original = optimizely.isFeatureEnabled.bind(optimizely)
  optimizely.isFeatureEnabled = (
    feature: string,
    overrideUserId: string,
    overrideAttributes?: any,
  ) => {
    const override = localStorage.getItem(`${OPTIMIZELY_OVERRIDE}${feature}`)

    if (override === 'true') {
      return true
    }
    if (override === 'false') {
      return false
    }

    return original(feature, overrideUserId, overrideAttributes)
  }
}
